import { Transporter } from './transporter.model';
export interface IAcceptance {
  id?: number;
  pickupZipCodeRule?: string | null;
  pickupCountry?: string | null;
  deliveryZipCodeRule?: string | null;
  deliveryCountry?: string | null;
  acceptanceDays?: number | null;
  pickupZipCodeData?: string | null;
  pickupZipCodeScore?: number | null;
  deliveryZipCodeData?: string | null;
  deliveryZipCodeScore?: number | null;
  offerId?: number | null;
  transporter?: Transporter;
}

export class Acceptance implements IAcceptance {
  constructor(
    public id?: number,
    public pickupZipCodeRule?: string | null,
    public pickupCountry?: string | null,
    public deliveryZipCodeRule?: string | null,
    public deliveryCountry?: string | null,
    public acceptanceDays?: number | null,
    public pickupZipCodeData?: string | null,
    public pickupZipCodeScore?: number | null,
    public deliveryZipCodeData?: string | null,
    public deliveryZipCodeScore?: number | null,
    public offerId?: number | null,
    public transporter?: Transporter
  ) {}
}

export function getAcceptanceIdentifier(acceptance: IAcceptance): number | undefined {
  return acceptance.id;
}
